import React, { useRef } from "react";
import "./NewCart.Module.css";
import axios from "axios";

import { useNavigate, Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import {
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Button as MUIButton,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useMediaQuery } from "react-responsive";
import { isAuthenticated } from "../../utils/auth/auth";
import { sendNewBuy } from "../../utils/cart/cart";
import { loginFunctionCart } from "../../features-slice/user/functions";
import GoogleLoginCart from "../login/GoogleLoginCart";
import UndoIcon from "@mui/icons-material/Undo"; // arriba del archivo
import ItemCart2 from "../../components/itemCart2/ItemCart2";

import CorreoImage from "../../assets/carticons/correo.png"
import DeliveryImage from "../../assets/carticons/delivery.png"
import MarketImage from "../../assets/carticons/local.png"
import WarningImage from "../../assets/carticons/warning.png"
import { currencyDisplay } from "../../utils/cart/cart";
import { obtenerCostoProductos } from "../../utils/products/products";

export default function PantallaDatos({
  close,
  setPantalla,
  setPurchase,
  total,
  descuentoId,
  costoConDescuento,
  costoConDescuentoPromo,
  descuentoAplicado
}) {
  const [loading, setLoading] = React.useState(false);
  const carrito = useSelector((state) => state.carrito);
  const [metodoPago, setMetodoPago] = React.useState("TARJETA");
  const uri = process.env.REACT_APP_BACK_URL;
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const [isLogin, setIsLogin] = React.useState(false);
  const navigate = useNavigate();

  const [openEye, setOpenEye] = React.useState(true);
  const toggleEye = () => setOpenEye(!openEye);

  const [userInfo, setUserInfo] = React.useState({ dni: "", password: "" });

  // Overlay inline (sin MUI Dialog)
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [acceptLock, setAcceptLock] = React.useState(false);

  const addressRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginFunctionCart(userInfo));
    if (user?.nombre) setIsLogin(false);
  };
  const handleChangeLogin = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  // Métodos de envío (2x2)
  const METHODS = [
    { value: "RETIRO",          title: "RETIRO EN LOCAL La Beautiquería", subtitle: "gratis" },
    { value: "RETIRO_CASILDA",  title: "RETIRO PICK UP POINT Casilda",    subtitle: "gratis" },
    { value: "CADETE",          title: "ENVÍO A DOMICILIO",               subtitle: "(a convenir)" },
    { value: "CORREO",          title: "RETIRO EN SUCURSAL ANDREANI",     subtitle: "a coordinar" },
  ];

  // Datos de contacto
  const [datosContacto, setDatosContacto] = React.useState({
    nombre: user?.nombre || "",
    apellido: user?.apellido || "",
    telefono: user?.telefono || "",
    dni: user?.dni || "",
    correo: user?.correo || "",
    domicilio: "",
    ciudad: "",
    cp: "",
    provincia: "",
    notas: "",
    password: !user?.nombre && "Beauti1234",
    role: "USER_ROLE",
  });

  // Método de envío elegido
  const [metodoEnvio, setMetodoEnvio] = React.useState(""); // '', 'RETIRO', 'RETIRO_CASILDA', 'CADETE', 'CORREO'

  // Mapea el código del método al título visible
const getMetodoEnvioTitle = (code) => {
  const found = METHODS.find(m => m.value === code);
  return found ? found.title : "";
};

// Renderiza una fila "Label: Valor" si hay valor
const ResumenFila = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{ display: "flex", gap: 8, fontSize: 14, marginBottom: 6 }}>
      <span style={{ color: "#6B7280", minWidth: 110 }}>{label}:</span>
      <span style={{ color: "#111827", fontWeight: 500 }}>{value}</span>
    </div>
  );
};

// Bloque visual contenedor
const ResumenBloque = ({ title, children }) => (
  <div
    style={{
      border: "1px solid #E5E7EB",
      borderRadius: 12,
      padding: 12,
      marginTop: 12,
      background: "#FAFAFA",
    }}
  >
    <div style={{ fontWeight: 600, fontFamily: "Poppins", marginBottom: 8, color: "#111827" }}>
      {title}
    </div>
    {children}
  </div>
);


  React.useEffect(() => {
    if (user?.nombre || user?._id) setIsLogin(false);
  }, [user]);

  React.useEffect(() => {
    if (user?.nombre) {
      setDatosContacto((prev) => ({
        ...prev,
        nombre: user.nombre || "",
        apellido: user.apellido || "",
        telefono: user.telefono || "",
        dni: user.dni || "",
        correo: user.correo || "",
        password: "",
        role: "USER_ROLE",
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatosContacto((prev) => ({ ...prev, [name]: value }));
  };

  // Validaciones
  const isAddressRequired = metodoEnvio === "CORREO" || metodoEnvio === "CADETE";
  const addressValid =
    !!datosContacto.domicilio && !!datosContacto.ciudad && !!datosContacto.cp && !!datosContacto.provincia;
  const contactValid = !!datosContacto.nombre && !!datosContacto.apellido && !!datosContacto.telefono;

  const canContinue = !loading && contactValid && !!metodoEnvio && (!isAddressRequired || addressValid);

  // Estado para abrir/cerrar el detalle del carrito en el overlay
const [showBagDetail, setShowBagDetail] = React.useState(false);

// Devuelve el label de la variante elegida (ej: color) si existe
const getVarianteElegida = (item) => {
  if (!item?.varianteId || !Array.isArray(item?.variantes)) return null;
  const v = item.variantes.find(v => v?._id === item.varianteId);
  // Ajustá qué campo mostrar (color / nombre / código) según tu modelo
  return v?.color || v?.nombre || null;
};


  // Confirmar pedido
  const handleConfirmPedido = async () => {
    if (!canContinue) return;
    setLoading(true);
    try {
      let currentUser = user;

      if (!isAuthenticated()) {
        const { data } = await axios.post(`${uri}/api/usuarios`, datosContacto);
        currentUser = data;
        toast.success("Usuario creado correctamente");

        const compra = await sendNewBuy(
          currentUser?.usuario?._id,
          carrito,
          currentUser,
          metodoPago,
          dispatch,
          { ...datosContacto },
          total,
          descuentoId,
          metodoEnvio
        );

        localStorage.setItem("totalTarjeta", JSON.stringify(costoConDescuento));
        localStorage.setItem("totalPromo", JSON.stringify(costoConDescuentoPromo));
        setPurchase(compra);
        setPantalla(2);
      } else {
        const compra = await sendNewBuy(
          user?._id,
          carrito,
          user,
          metodoPago,
          dispatch,
          { ...datosContacto },
          total,
          descuentoId,
          metodoEnvio
        );

        localStorage.setItem("totalTarjeta", JSON.stringify(costoConDescuento));
        localStorage.setItem("totalPromo", JSON.stringify(costoConDescuentoPromo));
        setPurchase(compra);
        setPantalla(2);
      }
    } catch (error) {
      console.error("Error al confirmar compra:", error);
      const mensaje = error?.response?.data?.msg;
      if (mensaje?.includes("Ya existe un usuario")) {
        toast.error("Ya existe un usuario con estos datos. Por favor, iniciá sesión para continuar.");
      } else {
        toast.error("Ocurrió un error al confirmar la compra. Intenta más tarde.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${uri}/api/auth/login`, {
        dni: datosContacto.dni,
        password: datosContacto.password,
      });
      toast.success("Sesión iniciada");
      localStorage.setItem("token", data.token);
      dispatch({ type: "LOGIN_SUCCESS", payload: data.usuario });
      setIsLogin(false);
      setPantalla(1);
    } catch (error) {
      toast.error("DNI o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  // Tarjetita de método
  // Tarjetita de método con ícono
const MetodoBtn = ({ value, title, subtitle }) => {
  const selected = metodoEnvio === value;

  const handleClick = () => {
    setMetodoEnvio(value);
    if (value === "CORREO" || value === "CADETE") {
      setTimeout(() => {
        addressRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  };

  // Elegir icono según value
  let iconSrc = null;
  if (value === "CORREO") iconSrc = CorreoImage;
  if (value === "CADETE") iconSrc = DeliveryImage;
  if (value === "RETIRO" || value === "RETIRO_CASILDA") iconSrc = MarketImage;

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-pressed={selected}
      style={{
        border: selected ? "2px solid #23563F" : "1px solid #E5E7EB",
        background: selected ? "#E9F5F0" : "#FFFFFF",
        padding: "14px 16px",
        borderRadius: "16px",
        fontFamily: "Poppins",
        textAlign: "left",
        cursor: "pointer",
        transition: "transform .06s ease, box-shadow .15s ease",
        boxShadow: selected ? "0 4px 14px rgba(0,0,0,.08)" : "0 1px 3px rgba(0,0,0,.05)",
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      {iconSrc && (
        <img
          src={iconSrc}
          alt={value}
          style={{ width: 28, height: 28, objectFit: "contain" }}
        />
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "#111827", lineHeight: 1.25 }}>
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 12, color: "#6B7280", marginTop: 4 }}>{subtitle}</div>
        )}
      </div>
    </button>
  );
};


  const ConfirmOverlay = () =>
  !showConfirm ? null : (
    <Box
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) setShowConfirm(false);
      }}
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        bgcolor: "rgba(0,0,0,0.24)",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: { xs: 4, md: 8 },
      }}
    >
      <Box
        role="dialog"
        aria-modal="true"
        tabIndex={-1}
        sx={{
          width: "min(560px, 92vw)",
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: 6,
          p: 2.5,
          maxHeight: "82vh",
          overflow: "auto",
        }}
      >
        {/* Header */}
        <Box sx={{ mb: 2, display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
          <img style={{ width: isMobile && "30px", height: "30px" }} src={WarningImage} alt="warningimage" />
          <Typography sx={{ fontFamily: "Poppins", fontWeight: 600, fontSize: 18 }}>
            VERIFICÁ QUE ESTÉ TODO BIEN
          </Typography>
        </Box>

        <Typography sx={{ fontFamily: "Poppins", fontSize: 14, mb: 1 }}>
          Si ves algún error en tu dirección u otro dato, modificalo antes de avanzar.
        </Typography>

        {/* ========== NUEVO: Resumen de datos ========== */}
        <ResumenBloque title="Resumen de tus datos">
          <ResumenFila label="Nombre" value={datosContacto?.nombre} />
          <ResumenFila label="Apellido" value={datosContacto?.apellido} />
          <ResumenFila label="Teléfono" value={datosContacto?.telefono} />
          <ResumenFila label="DNI" value={datosContacto?.dni} />
          <ResumenFila label="Correo" value={datosContacto?.correo} />
        </ResumenBloque>

        {metodoEnvio && (
          <ResumenBloque title="Entrega">
            <ResumenFila label="Método elegido" value={getMetodoEnvioTitle(metodoEnvio)} />
            {(metodoEnvio === "CORREO" || metodoEnvio === "CADETE") && (
              <>
                <ResumenFila label="Domicilio" value={datosContacto?.domicilio} />
                <ResumenFila label="Ciudad" value={datosContacto?.ciudad} />
                <ResumenFila label="Provincia" value={datosContacto?.provincia} />
                <ResumenFila label="Código Postal" value={datosContacto?.cp} />
                <ResumenFila label="Notas" value={datosContacto?.notas} />
              </>
            )}
            {(metodoEnvio === "RETIRO" || metodoEnvio === "RETIRO_CASILDA") && (
              <div style={{ fontSize: 13, color: "#374151", marginTop: 6 }}>
                Recordá que te vamos a contactar por WhatsApp para coordinar el retiro.
              </div>
            )}
          </ResumenBloque>
        )}


        {/* ========== FIN NUEVO ========== */}

        {/* ======= DETALLE DE LA BAG (toggle) ======= */}
<Box sx={{ mt: 2 }}>
  <MUIButton
    size="small"
    onClick={() => setShowBagDetail(prev => !prev)}
    sx={{ textTransform: "none", color: "#23563F" }}
  >
    {showBagDetail ? "Ocultar detalle de la bag" : "Ver detalle de la bag"}
  </MUIButton>

  {showBagDetail && (
    <div
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: 12,
        padding: 12,
        marginTop: 8,
        background: "#FAFAFA",
      }}
    >
      {/* Encabezado */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ fontWeight: 600, fontFamily: "Poppins", color: "#111827" }}>
          Productos en tu bag
        </div>
        <div style={{ fontSize: 12, color: "#6B7280" }}>
          {carrito?.length || 0} ítem{(carrito?.length || 0) === 1 ? "" : "s"}
        </div>
      </div>

      {/* Lista de líneas */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {(carrito || []).map((item, idx) => {
          const variante = getVarianteElegida(item);
          return (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "8px 10px",
                borderRadius: 10,
                background: "#FFFFFF",
                border: "1px solid #E5E7EB",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: 14, color: "#111827", fontWeight: 600 }}>
                  {item?.nombre || "Producto"}
                </span>
                <span style={{ fontSize: 12, color: "#6B7280" }}>
                  {variante ? `Variante: ${variante}` : "Sin variante"}
                </span>
              </div>

              <div style={{ fontSize: 12, color: "#111827", fontWeight: 600 }}>
                x{item?.cantidad || 1}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )}
</Box>
{/* ======= FIN DETALLE DE LA BAG ======= */}


        <ul style={{ margin: "12px 0 12px 18px", padding: 0 }}>
          <li style={{fontSize:"12px"}}>Se generará tu orden en el sistema.</li>
          <li style={{fontSize:"12px"}}>
            La bag <b>no podrá modificarse.</b>
          </li>
          <li style={{fontSize:"12px"}}>Podrás elegir el medio de pago en el siguiente paso.</li>
        </ul>

        <FormControlLabel
          control={<Checkbox checked={acceptLock} onChange={(e) => setAcceptLock(e.target.checked)} />}
          label="Acepto que al continuar confirmo la compra y la bag no podrá modificarse."
          sx={{ alignItems: "start", mt: 1, mb: 2 }}
        />

        <Box sx={{ display: "flex", flexDirection:"column", gap: 1 }}>
         
          <MUIButton
            variant="contained"
            disabled={!acceptLock || loading}
            onClick={() => {
              setShowConfirm(false);
              setAcceptLock(false);
              handleConfirmPedido();
            }}
            sx={{ backgroundColor: "#23563F", "&:hover": { backgroundColor: "#1c4634" } }}
          >
            {loading ? "Confirmando..." : "Confirmar compra"}
          </MUIButton>
           <MUIButton sx={{color:"#23563F"}} onClick={() => setShowConfirm(false)}>Volver y editar</MUIButton>
        </Box>
      </Box>
    </Box>
  );


  return (
    <div
      style={{
        minWidth: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          backgroundColor:"#E9CED2",
          width:"100%",
          display:"flex",
          height:"26px",
          alignItems:"center",
          justifyContent:"center",
          fontFamily: "Poppins",
          color: "#565862",
          fontSize: isMobile ? "14px" : "14px",
          fontWeight: 400,
          mb: 2,
        }}
      >
        {isLogin ? "Iniciar Sesión" : "1. DATOS PERSONALES"}
      </Typography>

      {isLogin ? (
        <div style={{ marginTop: "2vh" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
            <div>
              <label htmlFor="dni">DNI:</label>
              <input
                className="form-control"
                type="text"
                name="dni"
                placeholder="Ingresá tu DNI"
                value={userInfo?.dni}
                onChange={handleChangeLogin}
              />
            </div>

            <Box
              sx={{
                backgroundColor: "#f9f9f9",
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "10px",
                fontSize: "14px",
                fontFamily: "Poppins",
                color: "#333",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <p style={{ marginBottom: "10px" }}>
                Si sos clienta de <b>la Beauti</b>, tu contraseña por defecto es:{" "}
                <code style={{ color: "#c62828", fontWeight: 500 }}>Beauti1234</code>
              </p>
              <p
                onClick={() => {
                  navigator.clipboard.writeText("Beauti1234");
                  toast.success("Contraseña copiada");
                }}
                style={{
                  color: "#1c4634",
                  fontSize: "14px",
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: 500,
                  margin: 0,
                }}
              >
                Copiar contraseña
              </p>
              <p style={{ marginTop: "10px", color: "#555" }}>
                Luego podés cambiar tu contraseña en cualquier momento desde tu perfil.
              </p>
            </Box>

            <div style={{ position: "relative", width: "100%" }}>
              <label htmlFor="password">Contraseña:</label>
              <input
                className="form-control"
                type={openEye ? "password" : "text"}
                name="password"
                placeholder="Ingresá tu contraseña"
                value={userInfo?.password}
                onChange={handleChangeLogin}
                style={{ paddingRight: "40px" }}
              />
              <span
                onClick={toggleEye}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  cursor: "pointer",
                  color: "#888",
                }}
              >
                <abbr title={openEye ? "Mostrar contraseña" : "Ocultar contraseña"}>
                  <i className={openEye ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </abbr>
              </span>
            </div>

            <Button
              variant="contained"
              sx={{
                marginTop: "2vh",
                width: "100%",
                height: "48px",
                backgroundColor: "#23563F",
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: 400,
                textTransform: "none",
                "&:hover": { backgroundColor: "#1c4634" },
                opacity: loading ? 0.7 : 1,
              }}
              disabled={loading || !userInfo?.dni || !userInfo?.password}
              onClick={handleSubmit}
            >
              {loading ? "Ingresando..." : "Ingresar"}
            </Button>

            <Button
              variant="text"
              sx={{ marginTop: "1vh", fontFamily: "Poppins", fontSize: "14px", color: "#23563F" }}
              onClick={() => setIsLogin(false)}
            >
              Volver
            </Button>
          </div>
        </div>
      ) : (
        <>
          <Typography
            sx={{
              fontFamily: "Poppins",
              color: "#474747",
              fontSize: isMobile ? "10px" : "10px",
              fontWeight: 400,
              mb: 2,
            }}
          >
           * Completá estos datos para que podamos coordinar la entrega de tu compra. 
          </Typography>
          
          {!isAuthenticated() && (
            <Box sx={{display:"flex",flexDirection:"column", gap:"0px", marginTop:"25px"}}>
              <Typography
                onClick={() => setIsLogin(true)}
                sx={{
                  fontFamily: "Poppins",
                  color: "#474747",
                  fontSize: isMobile ? "12px" : "12px",
                  fontWeight: 400,
                  mb: 2,
                  cursor: "pointer",
                }}
              >
                Si ya sos clienta, logueate y tus datos se cargan automáticamente.
              </Typography>
              <GoogleLoginCart />
            </Box>
          )}

          {/* Datos de contacto */}
          <div style={{ display: "flex", flexDirection: "column", gap: "15px", width: isMobile ? "90%" : "100%" }}>
            <div>
              <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="nombre">Nombre:</label>
              <input
                className="form-control"
                type="text"
                name="nombre"
                value={datosContacto?.nombre}
                onChange={handleChange}
                placeholder="Ingresá tu nombre"
              />
            </div>

            <div>
              <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="apellido">Apellido:</label>
              <input
                className="form-control"
                type="text"
                name="apellido"
                value={datosContacto?.apellido}
                onChange={handleChange}
                placeholder="Ingresá tu apellido"
              />
            </div>

            <div>
              <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="telefono">Teléfono:</label>
              <input
                className="form-control"
                type="text"
                name="telefono"
                value={datosContacto?.telefono}
                onChange={handleChange}
                placeholder="Ingresá tu teléfono"
              />
            </div>

            <div>
              <label style={{fontFamily:"Poppins", fontSize:"12px"}}  htmlFor="dni">DNI:</label>
              <input
                className="form-control"
                type="text"
                name="dni"
                value={datosContacto?.dni}
                onChange={handleChange}
                placeholder="Ingresá tu DNI"
              />
            </div>

            <div>
              <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="correo">Correo:</label>
              <input
                className="form-control"
                type="email"
                name="correo"
                value={datosContacto?.correo}
                onChange={handleChange}
                placeholder="Ingresá tu mail"
              />
            </div>
          </div>

          {/* Método de envío */}
          {contactValid && (
            <div style={{ width: isMobile ? "90%" : "100%", marginTop: 24 }}>
              <Typography sx={{ fontFamily: "Poppins", fontSize: 12, mb: 1 }}>
                ¿Cómo querés recibir tu compra?
              </Typography>

              <div
                style={{
                  display: "grid",
                  // gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                  gridTemplateColumns:  "1fr" ,
                  gap: 12,
                  alignItems: "stretch",
                }}
              >
                {METHODS.map((m) => (
                  <MetodoBtn key={m.value} value={m.value} title={m.title} subtitle={m.subtitle} />
                ))}
              </div>

              {/* Dirección condicionada */}
              {isAddressRequired && (
                <div ref={addressRef} style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
                  <div>
                    <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="domicilio">Domicilio:</label>
                    <input
                      className="form-control"
                      type="text"
                      name="domicilio"
                      value={datosContacto?.domicilio}
                      onChange={handleChange}
                      placeholder="Calle y número"
                    />
                  </div>

                  <div style={{ display: "flex", gap: 12, flexDirection: isMobile ? "column" : "row" }}>
                    <div style={{ flex: 1 }}>
                      <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="ciudad">Ciudad:</label>
                      <input
                        className="form-control"
                        type="text"
                        name="ciudad"
                        value={datosContacto?.ciudad}
                        onChange={handleChange}
                        placeholder="Ciudad"
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="provincia">Provincia:</label>
                      <input
                        className="form-control"
                        type="text"
                        name="provincia"
                        value={datosContacto?.provincia}
                        onChange={handleChange}
                        placeholder="Provincia"
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{fontFamily:"Poppins", fontSize:"12px"}} htmlFor="cp">CP:</label>
                      <input
                        className="form-control"
                        type="text"
                        name="cp"
                        value={datosContacto?.cp}
                        onChange={handleChange}
                        placeholder="Código Postal"
                      />
                    </div>
                  </div>

                  <div>
                    <label style={{fontFamily:"Poppins", fontSize:"12px"}}  htmlFor="notas">Notas (opcional):</label>
                    <textarea
                      className="form-control"
                      name="notas"
                      rows={3}
                      value={datosContacto?.notas}
                      onChange={handleChange}
                      placeholder="Referencias, horarios, timbre, etc."
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Botones */}
          <Box
            sx={{
              mt: "2vh",
              width: isMobile ? "90%" : "100%",
              display: "flex",
              flexDirection:"column",
              gap: "12px",
              justifyContent: "center",
            }}
          >
       

  <Box
  component="button"
  onClick={canContinue ? () => setShowConfirm(true) : undefined}
  disabled={!canContinue || loading}
  sx={{
    mt: "0vh",
    width: isMobile ? "100" : "100%",
    height: 48,
    border: "none",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 300,
    textTransform: "none",
    transition: "all .2s ease",
    bgcolor: canContinue ? "#23563F" : "#7f958c",
    color: "#fff",
    cursor: canContinue ? "pointer" : "not-allowed",
    opacity: loading ? 0.8 : 1,

    "&:hover": {
      bgcolor: canContinue ? "#1c4634" : "#7f958c",
      transform: canContinue ? "translateY(-1px)" : "none",
    },
    "&:active": {
      transform: canContinue ? "translateY(0)" : "none",
    },
    "&:disabled": {
      bgcolor: "#7f958c",
      color: "#e6e6e6",
      cursor: "not-allowed",
      boxShadow: "none",
      transform: "none",
    },
  }}
>
  {loading ? "Procesando..." : "Siguiente"}
</Box>

                 
<Button
  variant="contained"
  sx={{
    mt: "5vh",
    display:"flex",
    justifyContent:"center",
    width: isMobile ? "100%" : "100%",
    height: "48px",
    backgroundColor: "#23563F",
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "none",
    "&:hover": { backgroundColor: "#1c4634" },
    opacity: loading ? 0.7 : 1,
  }}
  onClick={() => setPantalla(1)}
>
  {loading ? (
    "Procesando..."
  ) : (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent:"center", gap: 1 }}>
     
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontWeight: 400,
          fontSize: 12,
          mb: 0.2,
        }}
      >
        Volver a <b>mi bag</b>
      </Typography>
       <UndoIcon sx={{ fontSize: 18 }} />
    </Box>
  )}
</Button>
          </Box>
        </>
      )}

      {/* Overlay inline de confirmación */}
      <ConfirmOverlay />
    </div>
  );
}
